module.exports = __webpack_public_path__ + "img/SketchPng4993a309a729988e6a9a29081fc05c054d6748bc46d90d2b3b5d819abf79bad0.7c1db304.png";